// Client for the practice-mode subscription API in server/index.js.
// `token` is the session token returned by signIn().

const post = async (path, body = {}) => {
  const res = await fetch(`/api/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.error || 'Request failed');
    error.status = res.status;
    throw error;
  }
  return data;
};

// Exchanges a Google ID token (from the Sign in with Google button) for { token, email }
export const signIn = (credential) => post('login', { credential });

// Sends the player to Stripe Checkout; they come back with ?session_id=...
export const startCheckout = async (token) => {
  const { url } = await post('checkout', { token });
  window.location.assign(url);
};

// Confirms a completed checkout session for this player
export const confirmCheckout = async (token, sessionId) => (await post('verify', { token, sessionId })).active;

// true/false from Stripe; throws if the API is unreachable or the token is rejected (status 401)
export const isSubscriptionActive = async (token) => (await post('status', { token })).active;

// Stripe-hosted page where the player can cancel or update their card
export const openBillingPortal = async (token) => {
  const { url } = await post('portal', { token });
  window.location.assign(url);
};
